import { useEffect } from "react";
import { useCoastguard } from "@cofano/coastguard2-frontend-client";
import { CircularProgress, Paper } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const URL_PARAMS = {
	state: "&state=",
	authorizationCode: "#code=",
};

export default function AuthorizeApplication() {
	const { instance: { authorizeApplication } } = useCoastguard();
	const location = useLocation();
	const state = location.state as { redirectLocation: string };

	const navigate = useNavigate();

	useEffect(() => {
		const authorizationCode = location.hash?.substring(URL_PARAMS.authorizationCode.length);

		if (authorizationCode != null && authorizationCode.length > 0) {
			authorizeApplication(authorizationCode).catch((err) => {
				console.error("Authorization error", err);
			}).finally(() => navigate(state?.redirectLocation || "/view"));
		}
	}, []);

	return (
		<Paper
			sx={{
				alignItems: "center",
				display: "flex",
				justifyContent: "center",
				position: "absolute",
				inset: 0,
			}}
		>
			<CircularProgress size={30} />
		</Paper>
	);
}
